<template>
  <div class="boardContainer">
    <div class="headerBox">
      <el-col :span="8">
        <div class="banner">
          <img src="../../../../../assets/img/log.jpg" alt/>
        </div>
      </el-col>
      <el-col :span="8"></el-col>
      <el-col :span="8">
        <div class="logoutBox">
          <el-dropdown>
          <span class="el-dropdown-link">
            <div class="headPortrait">
              <i class="el-icon-lx-profile" style="font-size: 64px;"></i>
            </div>
          </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <span>{{username}}</span>
              </el-dropdown-item>
              <el-dropdown-item v-if="username === 'admin'">
                <span @click="gotoBackup()">后台</span>
              </el-dropdown-item>
              <el-dropdown-item v-if="adAccount !== 1">
                <span @click="visible.pwdVisible=true">更改密码</span>
              </el-dropdown-item>
              <el-dropdown-item>
                <span @click="logout">登出系统</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-col>
    </div>
    <hr/>
    <div class="contentBox">
      <div class="intervalImg">
        <!-- <el-carousel :indicator-position="'none'" height="320px" indicator-position="outside"> -->
        <el-carousel :indicator-position="'none'" height="320px">
          <el-carousel-item>
            <img src="../../../../../assets/img/banner1.jpg" height="320px" width="100%" alt/>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="cardsBox" v-if="resources.length>0">
        <template v-for="(item, index) in resources">
          <el-row :key="index" :gutter="10">
            <template v-for="(resource, index1) in item.resources">
              <el-col :key="resource.id" :md="8">
                <el-card class="cardBox" :key="index1">
                  <div class="cardContentBox" @click="gotoPage(resource)">
                    <div class="cardIconBox">
                      <i :class="resource.resourceIcon" style="font-size: 40px;"></i>
                    </div>
                    <div class="cardContentTxt">{{ resource.resourceName }}</div>
                  </div>
                </el-card>
              </el-col>
            </template>
          </el-row>
        </template>
      </div>
      <!-- <div class="cardsBox" v-if="resources.length==0">
        <template v-for="(resource, index) in fixedResources">
          <el-card class="cardBox" :key="index">
            <div class="cardContentBox" @click="gotoPage(resource)">
              <div class="cardIconBox">
                <i :class="resource.resourceIcon" style="font-size: 40px;"></i>
              </div>
              <div class="cardContentTxt">{{resource.resourceName}}</div>
            </div>
          </el-card>
        </template>
      </div>-->
    </div>
    <!-- 修改密码弹出框 -->
    <el-dialog title="修改密码" :visible.sync="visible.pwdVisible" width="40%">
      <el-form>
        <el-form-item label="原密码">
          <el-input type="password" v-model="pwdInfo.pwd"></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input type="password" v-model="pwdInfo.newPwd"></el-input>
        </el-form-item>
        <el-form-item label="新密码确认">
          <el-input type="password" v-model="pwdInfo.confirmNewPwd"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible.pwdVisible = false">取 消</el-button>
        <el-button type="primary" @click="savePwd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {setToken, removeToken} from "../../../../admin/common/auth.js";

export default {
  data() {
    if (this.$route.query.token) {
      setToken(this.$route.query.token);
      this.$router.replace({
        path: '/work/board'
      });
    }
    ;
    return {
      visible: {
        pwdVisible: false
      }, 
      username: "",
      adAccount: 0,
      pwdInfo: {
        pwd: "",
        newPwd: "",
        confirmNewPwd: "",
        secondPwd: "",
        newSecondPwd: ""
      },
      resources: []
    };
  },
  created() {
    if (this.$route.query.token) {
    } else {
      this.getUser();
    }
  },
  methods: {
    getUser() {
      this.$axios({
        method: "get",
        url: "/api/user/getCurrent",
        withCredentials: true
      })
          .then(response => {
            //这里使用了ES6的语法
            if (response.data.code === 1) {
              // this.$message.success("获取用户信息成功");
              this.handleData(response.data.data);
            } else {
              this.$message.warning(response.data.message);
            }
          })
          .catch(error => {
            this.$message.error("获取用户信息失败");
            console.log(error); //请求失败返回的数据
          })
          .finally(() => {
          });

      this.$axios({
        method: "get",
        url: "/api/user/getCurrentUser",
        withCredentials: true
      })
          .then(response => {
            if (response.data.code == 1) {
              this.username = response.data.data.userName;
              this.adAccount = response.data.data.adAccount
            }
          })
          .catch(error => {
          })
          .finally(() => {
          });
    },
    handleData(roles) {
      let resources = [];
      for (let role of roles) {
        for (let resource of role.resources) {
          if (
              resource.tAdnResource.resourcePath == "''" ||
              resource.tAdnResource.resourcePath == null
          ) {
            continue;
          }
          //this.resources.push(resource.tAdnResource);
          resources.push(resource.tAdnResource);
        }
      }
      let sortResources = this.resourcesSort(resources);
      let i = 0;
      let rowIndex = 0;
      let row = {};
      row.id = rowIndex;
      row.resources = [];
      for (let r of sortResources) {
        row.resources.push(r);
        if ((i + 1) % 3 === 0 || i + 1 === sortResources.length) {
          this.resources.push(row);
          rowIndex++;
          row = {};
          row.id = rowIndex;
          row.resources = [];
        }
        i++;
      }
    },
    resourcesSort(resources) {
      let resourcesResult = [];
      let sortArr = [
        '渠道商管理',
        '渠道申请信息查看',
        '渠道认证申请',
        '渠道认证管理',
        '渠道认证审批',
        '服务商信息管理',
        '服务申请信息查看',
        '服务认证申请',
        '服务认证审批',
        'UCSA证书信息管理',
        'UCSA证书信息(公司)',
        'ISV签约认证管理'
      ];
      for (let i = 0; i < sortArr.length; i++) {
        for (let j = 0; j < resources.length; j++) {
          if (resources[j].resourceName === sortArr[i]) {
            resourcesResult.push(resources[j]);
            break;
          }
        }
      }
      for (let j = 0; j < resources.length; j++) {
        let contains = false;
        for (let i = 0; i < sortArr.length; i++) {
          if (resources[j].resourceName === sortArr[i]) {
            contains = true;
            break;
          }
        }
        if (!contains) {
          resourcesResult.push(resources[j]);
        }
      }
      return resourcesResult;
    },
    logout() {
      removeToken();
      this.$axios({
        method: "get",
        url: "/api/shiro/logout",
        withCredentials: true
      })
          .then(response => {
            //这里使用了ES6的语法
            if (response.data.code === 1) {
              this.$message.success("登出成功");
              // this.$router.push({path: "/work/login"});
            } else {
              this.$message.warning(response.data.message);
            }
          })
          .catch(error => {
            // this.$message.error("登出失败");
            console.log(error); //请求失败返回的数据
          })
          .finally(() => {
            this.$router.push({path: "/work/login"});
          });
    },
    gotoPage(resource) {
      this.$router.push({path: resource.resourcePath});//在当前窗口打开
      /*let routeData = this.$router.resolve({ path: resource.resourcePath});
      window.open(routeData.href, '_blank');//在新窗口中打开*/
    },
    gotoBackup() {
      this.$router.push({path: '/admin'})
    },
    savePwd() {
      this.$axios({
        method: "get",
        url: "/api/user/changePwd",
        withCredentials: true,
        params: {
          pwd: this.pwdInfo.pwd,
          newPwd: this.pwdInfo.newPwd,
          secondPwd: "1",
          newSecondPwd: "1"
        }
      })
          .then(response => {
            //这里使用了ES6的语法
            if (response.data.code == 1) {
              this.$message.success("修改密码成功，如有必要请自行重登系统");
            } else {
              this.$message.warning(response.data.message);
            }
          })
          .catch(error => {
            this.$message.error("修改密码失败");
            console.log(error); //请求失败返回的数据
          })
          .finally(() => {
            this.visible.pwdVisible = false;
            this.pwdInfo = {
              pwd: "",
              newPwd: "",
              confirmNewPwd: "",
              secondPwd: "",
              newSecondPwd: ""
            };
          });
    }
  }
};
</script>
<style type="text/css" scoped>
.boardContainer {
  width: 100%;
  height: 100%;
}

.boardContainer .headerBox {
  height: 100px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.boardContainer .headerBox .banner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 15px 0px 0px 10px;
  width: 150px
}

.boardContainer .headerBox .logoutBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-right: 60px;
  margin-top: 10px;
}

.boardContainer .headerBox .logoutBox .headPortrait {
  width: 60px;
  height: 60px;
  border-radius: 30px;
  overflow: hidden;
  border: 3px solid #eee;
  float: right;
}

.boardContainer .contentBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-wrap: wrap;
  padding: 5px 10px 0px 10px;
}

.boardContainer .intervalImg {
  width: 100%;
  height: 320px;
  background-color: blue;
}

.boardContainer .contentBox .cardsBox {
  margin-top: 10px;
  /* height: 100px; */
  /*background-color:blue;*/
  /* display: flex; */
  flex-direction: row;
}

.boardContainer .cardBox {
  background-color: #eee;
  border: 3px solid #ccc;
  display: flex;
  flex-direction: row;
  width: 360px;
  height: 80px;
  margin: 10px 20px 4px 4px;
}

.boardContainer .cardBox .el-card__body {
  /*padding:0;*/
}

.boardContainer .cardBox .cardContentBox {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.boardContainer .cardBox .cardContentTxt {
  height: 100%;
  width: 260px;
  /*text-align: center;*/
  line-height: 50px;
  padding-left: 30px;
}

.boardContainer .cardIconBox {
  text-align: center;
  height: 100%;
}

.el-carousel__indicator {
  display: none;
}

/* .footerBox{
        position: absolute;
        bottom:40px;
        width: 80%;
        height:40px;
    }
    .MenuBox{
        width: 50px;
        height: 50px;
        margin: 0 auto;
        border-radius: 25px;
        background-color: yellow;
    }*/
</style>